import { PromotionBanner } from "@clipboard-health/ui-components";
import { useHistory } from "react-router-dom";

import { useNCOrientationStatus } from "./useNCOrientationStatus";

interface NCOrientationBannerProps {
  navigationPath: string;
}

export function NCOrientationBanner(props: NCOrientationBannerProps) {
  const { navigationPath } = props;
  const history = useHistory();
  const { shouldShow } = useNCOrientationStatus();

  if (!shouldShow) {
    return null;
  }

  return (
    <PromotionBanner
      title="North Carolina Orientation"
      subtitle="You must complete this orientation before you start booking shifts in North Carolina."
      icon="unlock"
      borderVariant="none"
      backgroundColor={(theme) => theme.palette.documents!.neutral.gradient}
      titleColor={(theme) => theme.palette.text.primary}
      ctaButtonText="Start Orientation"
      sx={(theme) => ({
        height: "100%",
        minHeight: 220,
        border: `1px solid ${theme.palette.divider}`,
        "& svg": { alignSelf: "flex-start" },
      })}
      onClick={() => {
        history.push(navigationPath);
      }}
    />
  );
}
